{
 "doc": "Flame presets. t: [weight, a, b, c, d, e, f, variation] with x' = a x + b y + c, y' = d x + e y + f; variations 0 linear, 1 sinusoidal, 2 spherical, 3 swirl, 4 horseshoe, 5 julia. swing: the linear part's swing amplitude (rad); orbit: the offset's rotation amplitude (rad, >= pi = full turns). swing and orbit are set by tools/validate-flames.mjs --fix.",
 "presets": [
  {
   "name": "galaxy",
   "scale": 0.304,
   "t": [
    [
     0.85,
     0.82,
     -0.38,
     0,
     0.38,
     0.82,
     0.05,
     3
    ],
    [
     0.15,
     0.35,
     0,
     0.6,
     0,
     0.35,
     0,
     2
    ]
   ],
   "swing": 0.35,
   "orbit": 3.1416
  },
  {
   "name": "spiral-arm",
   "scale": 0.5,
   "t": [
    [
     0.9777122259140014,
     -0.719,
     -0.485,
     0.027,
     0.453,
     -0.771,
     0.138,
     3
    ],
    [
     0.710758638381958,
     0.959,
     -0.209,
     0.658,
     0.375,
     0.536,
     0.419,
     3
    ],
    [
     0.5322832584381103,
     0.641,
     0.165,
     -0.217,
     -0.138,
     0.767,
     0.309,
     0
    ]
   ],
   "swing": 0.35,
   "orbit": 3.1416
  },
  {
   "name": "julia-flower",
   "scale": 1.002,
   "t": [
    [
     0.5,
     0.6,
     0.2,
     0.1,
     -0.2,
     0.6,
     0.3,
     5
    ],
    [
     0.3,
     0.5,
     -0.5,
     0,
     0.5,
     0.5,
     0,
     5
    ],
    [
     0.2,
     0.4,
     0,
     0.4,
     0,
     0.4,
     -0.2,
     3
    ]
   ],
   "swing": 0.35,
   "orbit": 3.1416
  },
  {
   "name": "ring-lace",
   "scale": 1.025,
   "t": [
    [
     0.5,
     0.56,
     -0.48,
     0.2,
     0.48,
     0.56,
     0,
     5
    ],
    [
     0.5,
     -0.56,
     -0.48,
     -0.2,
     0.48,
     -0.56,
     0,
     5
    ]
   ],
   "swing": 0.35,
   "orbit": 0
  },
  {
   "name": "horseshoe-rose",
   "scale": 0.943,
   "t": [
    [
     0.5,
     0.7,
     0.4,
     0,
     -0.4,
     0.7,
     0,
     4
    ],
    [
     0.3,
     -0.3,
     0.7,
     0.3,
     -0.7,
     -0.3,
     0.2,
     5
    ],
    [
     0.2,
     0.4,
     0,
     0,
     0,
     0.4,
     0.6,
     3
    ]
   ],
   "swing": 0.35,
   "orbit": 3.1416
  },
  {
   "name": "swirl-shell",
   "scale": 0.646,
   "t": [
    [
     0.7,
     0.9,
     -0.2,
     0,
     0.2,
     0.9,
     0,
     3
    ],
    [
     0.3,
     0.25,
     0,
     1,
     0,
     0.25,
     0,
     0
    ]
   ],
   "swing": 0.35,
   "orbit": 3.1416
  },
  {
   "name": "curl",
   "scale": 0.5,
   "t": [
    [
     0.5313759565353393,
     -0.612,
     -0.63,
     0.508,
     0.575,
     -0.671,
     -0.442,
     4
    ],
    [
     1.067333561182022,
     -0.127,
     -0.727,
     -0.33,
     0.397,
     -0.232,
     -0.682,
     4
    ]
   ],
   "swing": 0.35,
   "orbit": 3.1416
  },
  {
   "name": "sine-veil",
   "scale": 0.819,
   "t": [
    [
     0.5,
     1.1,
     0.4,
     0.2,
     -0.4,
     1.1,
     0,
     1
    ],
    [
     0.3,
     0.4,
     -0.6,
     0,
     0.6,
     0.4,
     0,
     5
    ],
    [
     0.2,
     0.3,
     0,
     0.8,
     0,
     0.3,
     0,
     3
    ]
   ],
   "swing": 0.35,
   "orbit": 3.1416
  },
  {
   "name": "four-petal",
   "scale": 1.089,
   "t": [
    [
     0.25,
     0.45,
     0.2,
     0.5,
     -0.2,
     0.45,
     0,
     4
    ],
    [
     0.25,
     0.45,
     0.2,
     -0.5,
     -0.2,
     0.45,
     0,
     4
    ],
    [
     0.25,
     0.45,
     0.2,
     0,
     -0.2,
     0.45,
     0.5,
     3
    ],
    [
     0.25,
     0.45,
     0.2,
     0,
     -0.2,
     0.45,
     -0.5,
     3
    ]
   ],
   "swing": 0.35,
   "orbit": 2
  },
  {
   "name": "yin",
   "scale": 0.5,
   "t": [
    [
     0.34084720611572267,
     -0.53,
     -0.399,
     -0.47,
     0.726,
     -0.291,
     0.597,
     0
    ],
    [
     1.1752236604690551,
     1.096,
     0.159,
     0.157,
     -0.287,
     0.608,
     -0.424,
     3
    ],
    [
     0.646845531463623,
     -0.552,
     0.722,
     -0.518,
     -0.567,
     -0.703,
     0.223,
     3
    ]
   ],
   "swing": 0.35,
   "orbit": 3.1416
  },
  {
   "name": "bubbles",
   "scale": 0.5,
   "t": [
    [
     0.5936132192611694,
     0.866,
     -0.338,
     -0.576,
     0.532,
     0.551,
     0.593,
     5
    ],
    [
     0.8070692539215087,
     -0.91,
     0.148,
     -0.038,
     -0.184,
     -0.73,
     -0.019,
     4
    ]
   ],
   "swing": 0.35,
   "orbit": 3.1416
  },
  {
   "name": "flare",
   "scale": 0.5,
   "t": [
    [
     0.4652190923690796,
     -0.409,
     0.837,
     0.272,
     -0.659,
     -0.52,
     0.36,
     4
    ],
    [
     0.4871415615081787,
     0.128,
     0.458,
     0.136,
     -0.849,
     0.069,
     0.003,
     3
    ]
   ],
   "swing": 0.35,
   "orbit": 3.1416
  }
 ]
}